<p>У вас еще нет избранных товаров</p>
<p>
  Чтобы пополнить список
  <a sdLink [routerLink]="{ cxRoute: 'category', params: { code: 'stroitelnye-materialy-5521' } } | cxUrl">
    перейдите в каталог
  </a>
</p>
